import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FleetDetailsDto, FleetListDto } from "~/api/GeneratedApi";
import { FleetItemInternal } from "~/pages/fleets-page/FleetItems";

// Define a type for the slice state
interface FleetState {
  selectedFleet?: FleetDetailsDto | null;
  selectedMapFleet?: FleetDetailsDto | null;
  allFleets?: FleetListDto[] | null;
  selectedMapFleetId?: number | null;
  selectedFleetItemId?: string | null;
  convertedItems: FleetItemInternal[] | null;
}

// Define the initial state using that type
const initialState: FleetState = {
  selectedFleet: null,
  allFleets: null,
  selectedMapFleetId: null,
  selectedFleetItemId: null,
  convertedItems: null,
};

export const fleetSlice = createSlice({
  name: "fleet",
  initialState,
  reducers: {
    setSelectedFleetItemId: (state, action: PayloadAction<string | null>) => {
      state.selectedFleetItemId = action.payload;
    },
    setAllFleets: (state, action: PayloadAction<FleetListDto[] | null>) => {
      state.allFleets = action.payload;
    },
    setSelectedMapFleetId: (state, action: PayloadAction<number | null>) => {
      state.selectedMapFleetId = action.payload;
    },
    setSelectedFleet: (
      state,
      action: PayloadAction<FleetDetailsDto | null>,
    ) => {
      state.selectedFleet = action.payload;
    },
    setSelectedMapFleet: (
      state,
      action: PayloadAction<FleetDetailsDto | null>,
    ) => {
      state.selectedMapFleet = action.payload;
    },
    setConvertedItems: (
      state,
      action: PayloadAction<FleetItemInternal[] | null>,
    ) => {
      state.convertedItems = action.payload;
    },
  },
});

export const {
  setSelectedFleetItemId,
  setAllFleets,
  setSelectedMapFleetId,
  setConvertedItems,
  setSelectedFleet,
  setSelectedMapFleet,
} = fleetSlice.actions;

export default fleetSlice.reducer;
